module.exports = __webpack_public_path__ + "img/asx_drive.612835d5.jpg";